import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { StringFormatter } from '@repo/toolkit/string'
import { PhoneInput, PhoneInputProps } from '@repo/ui/phone-input'
import Typography from '@repo/ui/typography'

import useAuth from '../../../lib/hooks/use-auth'
import useTranslate from '../../../lib/hooks/use-translate'
import { formatErrorMessage } from '../../../lib/utils/functions/format-error-message'
import { useFormField } from '../forms/form'

const ControlledPhoneInput: React.FC<PhoneInputProps> = ({
  required,
  value,
  onChange,
  ...props
}) => {
  const { error } = useFormField()
  const errorMessage = error?.message

  const { currentLanguage } = useTranslate()
  const { user } = useAuth<true>()

  return (
    <div className="relative">
      {props?.label && (
        <Typography
          variant={'label'}
          className={'absolute bg-white left-2 -top-2 px-1 !text-[9px] z-[5]'}
        >
          {StringFormatter.isRequired(props.label, required)}
        </Typography>
      )}
      <PhoneInput
        {...props}
        // In the OL space every phone field defaults to the OL's own country
        defaultCountry={user?.ol?.phoneCountry ?? props.defaultCountry}
        value={value ?? undefined}
        onChange={(value) => {
          if (!value) {
            onChange?.(null)
            return
          }

          onChange?.(value)
        }}
        hasError={!!error}
        language={currentLanguage}
      />
      {errorMessage && (
        <Typography variant="small" color={tailwindColors.red.DEFAULT}>
          {formatErrorMessage(errorMessage)}
        </Typography>
      )}
    </div>
  )
}

export default ControlledPhoneInput
